import {
  DocBody,
  DocHeader,
  LogoBox,
  DocTitle,
  SectionHeader,
  SectionTitle,
  AgreeGroup,
  AgreeText,
  AgreeCheck,
  TableWrap,
  TableCol,
  FullCol,
  LabelCell,
  ValueCell,
  TermBody,
  SignDateRow,
  SignDateBlank,
  SignRow,
  SignItem,
  SignLabel,
  SignNameBlank,
  SignStampBox,
  ThanksText,
  ThanksStrong,
  ThanksNormal,
} from './ElectronicContractPreviewStyled';

// 개인정보 표 행 — 4컬럼 (라벨/값/라벨/값)
const PERSONAL_ROWS = [
  { leftLabel: '성명', rightLabel: '성별' },
  { leftLabel: '연락처', rightLabel: '생년월일' },
  { leftLabel: '주소', rightLabel: '담당자' },
];

// 상품정보 표 행
const PRODUCT_ROWS = [
  { leftLabel: '상품명', rightLabel: '상품분류' },
  { leftLabel: '잔여횟수', rightLabel: '잔여기간' },
];

// 중지정보 표 행
const STOP_ROWS = [
  { leftLabel: '중지기간', rightLabel: '사용일수' },
  {
    leftLabel: (
      <>
        잔여중지
        <br />
        가능횟수
      </>
    ),
    rightLabel: (
      <>
        잔여중지
        <br />
        가능일수
      </>
    ),
    key: '잔여중지',
  },
];

// 중지 계약서 미리보기 (Figma node 7849:10274)
const ElectronicContractPreviewPageSuspension = ({ name, branchName, logoUrl, sealUrl, termSections = [] }) => (
  <DocBody>
    {/* 로고 + 제목 */}
    <DocHeader>
      <LogoBox>{logoUrl && <img src={logoUrl} alt="로고" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />}</LogoBox>
      <DocTitle>{name || '바디스위치 피트니스 중지 계약서'}</DocTitle>
      <div style={{ width: 120, flexShrink: 0 }} />
    </DocHeader>

    {/* 개인정보 */}
    <FullCol>
      <SectionHeader rounded="top">
        <SectionTitle>개인정보</SectionTitle>
      </SectionHeader>
      {PERSONAL_ROWS.map(row => (
        <TableWrap key={row.leftLabel}>
          <TableCol fixed={100}>
            <LabelCell>{row.leftLabel}</LabelCell>
          </TableCol>
          <TableCol>
            <ValueCell />
          </TableCol>
          <TableCol fixed={100}>
            <LabelCell>{row.rightLabel}</LabelCell>
          </TableCol>
          <TableCol>
            <ValueCell />
          </TableCol>
        </TableWrap>
      ))}
    </FullCol>

    {/* 상품정보 */}
    <FullCol>
      <SectionHeader rounded="top">
        <SectionTitle>상품정보</SectionTitle>
      </SectionHeader>
      {PRODUCT_ROWS.map(row => (
        <TableWrap key={row.leftLabel}>
          <TableCol fixed={100}>
            <LabelCell>{row.leftLabel}</LabelCell>
          </TableCol>
          <TableCol>
            <ValueCell />
          </TableCol>
          <TableCol fixed={100}>
            <LabelCell>{row.rightLabel}</LabelCell>
          </TableCol>
          <TableCol>
            <ValueCell />
          </TableCol>
        </TableWrap>
      ))}
    </FullCol>

    {/* 중지정보 */}
    <FullCol>
      <SectionHeader rounded="top">
        <SectionTitle>중지정보</SectionTitle>
      </SectionHeader>
      {STOP_ROWS.map((row, idx) => (
        <TableWrap key={row.key || idx}>
          <TableCol fixed={100}>
            <LabelCell cellHeight={idx === 1 ? 64 : 32}>{row.leftLabel}</LabelCell>
          </TableCol>
          <TableCol>
            <ValueCell cellHeight={idx === 1 ? 64 : 32} />
          </TableCol>
          <TableCol fixed={100}>
            <LabelCell cellHeight={idx === 1 ? 64 : 32}>{row.rightLabel}</LabelCell>
          </TableCol>
          <TableCol>
            <ValueCell cellHeight={idx === 1 ? 64 : 32} />
          </TableCol>
        </TableWrap>
      ))}
      <TableWrap>
        <TableCol fixed={100}>
          <LabelCell>중지사유</LabelCell>
        </TableCol>
        <TableCol>
          <ValueCell />
        </TableCol>
      </TableWrap>
    </FullCol>

    {/* 약관 섹션 — 선택된 조항만 표시 */}
    {termSections.map(term => (
      <FullCol key={term.title}>
        <SectionHeader rounded="top">
          <SectionTitle>{term.title}</SectionTitle>
          <AgreeGroup>
            <AgreeText>아래 약관을 확인하였으며 동의합니다.</AgreeText>
            <AgreeCheck />
          </AgreeGroup>
        </SectionHeader>
        <TermBody>{term.body}</TermBody>
      </FullCol>
    ))}

    {/* 서명 */}
    <SignDateRow>
      <SignDateBlank />
      <span>년</span>
      <SignDateBlank />
      <span>월</span>
      <SignDateBlank />
      <span>일</span>
    </SignDateRow>
    <SignRow>
      <SignItem>
        <SignLabel>담당자</SignLabel>
        <SignNameBlank />
        <SignStampBox filled>
          {sealUrl && <img src={sealUrl} alt="직인" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />}
        </SignStampBox>
      </SignItem>
      <SignItem>
        <SignLabel>계약자</SignLabel>
        <SignNameBlank />
        <SignStampBox />
      </SignItem>
    </SignRow>

    {/* 감사 문구 */}
    <ThanksText>
      <ThanksStrong>{branchName || '지점'}</ThanksStrong>
      <ThanksNormal> 중지 신청이 정상적으로 접수되었습니다.</ThanksNormal>
    </ThanksText>
  </DocBody>
);

export default ElectronicContractPreviewPageSuspension;
